import React from 'react'
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function PageBreadcome(props) {

    const navigate = useNavigate();
    return (
        <div className="beadcome-header">
            <div>
                <div className='header-btn-block'>
                    <div className='d-flex'>
                        <button
                            className="back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft />
                        </button>
                    </div>

                    <div className='text-section'>
                        <h2>{props.heading}</h2>
                        <p>{props.sub_heading}</p>
                    </div>
                </div>
            </div>

            {/* <Button className="btn-add">
                                <i className="bx bx-plus"></i>
                                Add Subscription
                            </Button> */}

        </div >
    )
}

export default PageBreadcome;
